





import { CentralNotificacoesService, TipoNotificacao } from '@/services/central-notificacao.service';
import Vue from 'vue';
import { Component, ModelSync } from 'vue-property-decorator';

@Component
export default class TipoNotificacaoSelect extends Vue {
    @ModelSync('value', 'input', { type: Number, default: null })
    idTipoNotificacao!: number | null;
    tiposNotificacao: TipoNotificacao[] = [];
    loading = false;

    mounted() {
        this.carregarTiposNotificacao();
    }

    async carregarTiposNotificacao() {
        this.loading = true;
        this.tiposNotificacao =
            await CentralNotificacoesService.listarTiposNotificacao();
        this.loading = false;
    }
}

